import { useEffect, useRef, useState } from 'react';
import Container from 'react-bootstrap/Container';
import { RootState } from '../../store/config/types';
import { AppActions } from './../../store/config/ActionTypes';
import { ThunkDispatch } from 'redux-thunk';
import { executeReplacePaymentMethod } from '../../store/action_creators/subscriber.actions';
import { connect, ConnectedProps } from 'react-redux';
import useQuery from '../../hooks/useQuery';
import Subscribe from '../../components/Subscribe/Subscribe';
import Iframe from '../../components/PlexoComponents/Iframe';
import PaymentMethod from '../../components/PlexoComponents/PaymentMethod';

declare global {
  interface Window {
    attachEvent: any;
  }
}

window.attachEvent = window.attachEvent || {};

const mapStateToProps = (state: RootState) => ({
  subscriber: state.subscriber,
  subscriptionTypes: state.subscriptionTypes,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, any, AppActions>) => ({
  executeReplacePaymentMethod: (userId: string) => dispatch(executeReplacePaymentMethod(userId)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

function RenovatePaymentMethod({
  subscriber,
  subscriptionTypes,
  executeReplacePaymentMethod,
}: PropsFromRedux) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const queryParams = useQuery();
  const userId = queryParams.get('userId');

  const [externalId, setExternalId] = useState<string>('');
  const [subscriptionTypeId, setSubscriptionTypeId] = useState<string>('');
  const [replaceInstrument, setReplaceInstrument] = useState<boolean>(false);

  useEffect(() => {
    window.addEventListener('message', receiveMessage);

    return () => {
      window.removeEventListener('message', receiveMessage);
    };
  });

  function receiveMessage(e: MessageEventInit) {
    console.log(e);
    if (e.data.message === 'redirectError') {
      // history.push(`/result?errorCode=${e.data.payload}`);
    } else if (e.data.message === 'redirectSuccess') {
      setExternalId(userId!);
      setSubscriptionTypeId(e.data.payload.subscriptionTypeId);
      setReplaceInstrument(true);
    }
  }

  useEffect(() => {
    executeReplacePaymentMethod(userId!);
  }, [executeReplacePaymentMethod, userId]);

  return (
    <Container>
      <Subscribe
        mustSubscribe={false}
        externalId={externalId}
        subscriptionTypeId={subscriptionTypeId}
        replaceInstrument={replaceInstrument}
      />
      <div className="renovate-payment-method">
        <div>
          <div className="left-card">
            <div className="title">
              <div>Ingresá tu nuevo medio de pago</div>
            </div>
            <PaymentMethod />
          </div>
        </div>
        <div className="right-card">
          <Iframe
            iframeRef={iframeRef}
            plexoUrl={subscriber.plexoUrl}
            replacePaymentMethodPlexoUrl={subscriber.replacePaymentMethodPlexoUrl}
          />
        </div>
      </div>
    </Container>
  );
}

export default connector(RenovatePaymentMethod);
